export default {
  // 人员矩阵
  personnelMatrix: {
    //流程配置器
    personnelMatrix: '人员矩阵',
    matrixConfiguration: '矩阵配置',
    selectMatrix: '选择人员矩阵',
    selectMappingRelationship: '选择映射关系',
    selectPersonnelMaintenance: '选择人员维护',
    selectReferenceDep: '选择参照部门',
    formData: '表单数据',
    selectApprovalPersonnel: '选择审批人员',
    jobPosSelect: '岗位选择',
    placeholder: {
      matrix: '请选择矩阵',
      depCompoment: '请选择部门组件',
      josPos: '请选择岗位'
    },
    //矩阵列表
    personnelMatrixNote:
      '对于人员较多,关系较复杂的公司,人员矩阵设置可以满足多维度人员关系对应的需求',
    searchPlaceholder: '搜索矩阵名称或编码',
    noData: '暂无数据',
    referenceQuery: '引用查询',
    addMatrix: '新增矩阵',
    matrixName: '矩阵名称',
    matrixCode: '矩阵编码',
    delMatrixReferenceTip: '请先在【审批流程】中清空数据后进行删除',
    changeMatrixStatusReferenceTip: '请先在【审批流程】中清空或删除引用后进行关闭',
    jobMaintenance: '岗位维护',
    mappingRelationship: '映射关系',
    jobMaintenanceTip: '先维护岗位矩阵中所涉及的各个审批岗位,再维护映射关系',
    addJobPosition: '添加岗位',
    editJobPosition: '编辑岗位',
    jobPositionName: '岗位名称',
    jobPositionCode: '岗位编码',
    editJobPositionEmptyTip: '岗位不存在',
    delJobPosImportTip: '请先在【映射关系】中清空人员数据后进行删除',
    // 映射关系页面
    orgProtection: '岗位维护',
    removeFilter: '筛选移除',
    department: '部门',
    position1: '岗位1',
    position2: '岗位2',
    position3: '岗位3',
    selectOrgTip: '请选择左侧组织节点查看映射关系',
    mappingTip: '岗位维护中成员,绑定该{dept}个对应的{count}位人员',
    batchMaintenance: '批量维护',
    exportMatrix: '导出矩阵',
    selectPersonnel: '选择人员',
    searchPersonnel: '搜索人员',
    add: '新增',
    syncReplaceChildren: '同步替换下级',
    // 批量维护弹窗
    downloadLatestTemplate: '下载最新模板',
    importTemplate: '导入模板',
    complete: '完成',
    prepareImportData: '请按照数据模版的格式准备要导入的数据',
    batchMaintenanceNote1: '模版中的表头名称不可更改, 表头行不能删除, 行内容不可删除或增加',
    batchMaintenanceNote2: '导入格式为xlsx, 数据导入为覆盖导入',
    batchMaintenanceNote3:
      '人员必须为组织架构内存在的人员工号, 否则导入失败, 每次必须下载最新模板; 多人用英文, 隔开',
    clickDownloadTemplate: '点击下载最新导入模板',
    selectImportTemplate: '请选择需要导入的数据模版',
    addFile: '添加文件',
    fileName: '文件名称',
    previousStep: '上一步',
    startImport: '开始导入',
    addSuccess: '添加成功',
    importExceptionDescription: '导入异常说明',
    serialNumber: '序号',
    listHeaderAdjusted: '列表头字段有调整',
    rowHeaderAdjusted: '行表头字段有调整',
    personnelNotExist: '人员不存在',
    mattersNeedingAttention: '注意事项',
    nextStep: '下一步',
    onlyOneFile: '每次仅允许上传1个文件',
    pleaseSelectFile: '请选择文件',
    downloadStart: '开始下载',
    importFailed: '导入失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败'
  }
}
